import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

function Footer({ sx = {} }) {
  return (
    <Box
      component="footer"
      sx={{
        mt: 6,
        py: 3,
        px: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        textAlign: 'center',
        ...sx,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        &copy; {new Date().getFullYear()} BlueShift Auto. All rights reserved.
      </Typography>
      <Box sx={{ mt: 0.5, display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Link component={RouterLink} to="/privacy" variant="caption" color="text.secondary" underline="hover">
          Privacy Policy
        </Link>
        <Link component={RouterLink} to="/terms" variant="caption" color="text.secondary" underline="hover">
          Terms of Use
        </Link>
      </Box>
    </Box>
  );
}

export default Footer;
